import { AxiosError } from 'axios';

// A backend exception thrown without a message carries its status name instead; that says nothing to a person
const statusNames = new Set([
  'Bad Request',
  'Unauthorized',
  'Forbidden',
  'Not Found',
  'Method Not Allowed',
  'Not Acceptable',
  'Request Timeout',
  'Conflict',
  'Gone',
  'Payload Too Large',
  'Unsupported Media Type',
  'Unprocessable Entity',
  'Precondition Failed',
  'ThrottlerException: Too Many Requests',
  'Internal Server Error',
  'Not Implemented',
  'Bad Gateway',
  'Service Unavailable',
  'Gateway Timeout',
]);

/** The message the backend wrote for a person, or undefined when there is none */
export function readableServerMessage(error: unknown) {
  const message = (error as AxiosError<any, any>)?.response?.data?.message?.message;

  if (!(error instanceof AxiosError) || !message || statusNames.has(message)) {
    return undefined;
  }

  return message;
}

/**
 * The code a backend exception was thrown with (`PHONE_TAKEN`, ...): a client that has to do
 * something other than show the text reads this, never the text.
 */
export function serverErrorCode(error: unknown): string | undefined {
  const code = (error as AxiosError<any, any>)?.response?.data?.message?.code;

  return error instanceof AxiosError && typeof code === 'string' ? code : undefined;
}

/** Another field a coded exception was thrown with (`inviteId` beside `ALREADY_INVITED`, ...). */
export function serverErrorDetail(error: unknown, key: string): unknown {
  return error instanceof AxiosError ? error.response?.data?.message?.[key] : undefined;
}

export function extractErrorMessage(error: unknown, customeMessage?: string): string {
  return readableServerMessage(error) ?? customeMessage ?? 'Something went wrong. Please try again later.';
}
